import type { Job } from '../../../types';
import type { JobFiltersScheme } from '../types';
import { applySalaryFilter } from './applySalaryFilter';

type FilterValueForKey<K extends keyof JobFiltersScheme> =
  JobFiltersScheme[K][number];

type FilterFn<K extends keyof JobFiltersScheme> = (
  job: Job,
  value: FilterValueForKey<K>
) => boolean;

type AnyFilterFn = FilterFn<keyof JobFiltersScheme>;

type FilterConfig = { [K in keyof JobFiltersScheme]: FilterFn<K> };

const filter = (field: string, value: string) =>
  field.toLowerCase().includes(value.toLowerCase());

const filterConfig = {
  company: (job, val) => filter(job.company, val),
  department: (job, val) => filter(job.department, val),
  location: (job, val) => filter(job.location, val),
  typeOfContract: (job, val) => filter(job.typeOfContract, val),
  salary: (job, val) => applySalaryFilter(job.salary, val),
  skills: (job, val) => job.skills.some((s) => filter(s.name, val))
} satisfies FilterConfig;

export function applyFilters(job: Job, appliedFilters: JobFiltersScheme) {
  return Object.entries(filterConfig).every(([key, fn]) => {
    const values = appliedFilters[key];

    return !values?.length || values.some((v) => (fn as AnyFilterFn)(job, v));
  });
}
